import { PropsWithChildren, useState } from "react";
import Header from "../../../components/header";
import SideBar from "../../../components/sidebar";
import AuthManager from "../../../core/oidc";
import { Outlet } from "react-router-dom";

const LayoutPrivate = (props: PropsWithChildren) => {

    const userName = AuthManager.getUserName();
    const [openSideBar, setopenSideBar] = useState(true);

    const handleOpenSideBar = () => {
        setopenSideBar(true);
    }

    const handleCloseSideBar = () => {
        setopenSideBar(false);
    }

    return (
        <div className="app-container">
            <SideBar isOpen={openSideBar} onClose={() => handleCloseSideBar()} />
            <div className="app-content">
                <Header userName={userName} isSideBarOpen={openSideBar} onMenuIconClick={() => handleOpenSideBar()} />
                <div className="page-layout">
                    <div className="page-layout-content">
                        <div className="content-box">
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LayoutPrivate;
